import { FirebaseOptions } from 'firebase/app';
import { environment } from 'src/environments/environment';

/** Custom auth hosts registered in Firebase + Google OAuth. */
export const DEFAULT_FIREBASE_AUTH_DOMAIN = 'dev-auth.healthexam.ai';
export const QA_FIREBASE_AUTH_DOMAIN = 'qa-auth.healthexam.ai';
export const PROD_FIREBASE_AUTH_DOMAIN = 'auth.healthexam.ai';

const FIREBASE_APP_HOST = 'health-exam-ai-apps.firebaseapp.com';

/**
 * Resolve Firebase authDomain for the current page origin.
 * - dev-auth.healthexam.ai → same host (Continue with Google redirect URI)
 * - localhost ng serve → localhost:port + proxy.conf.js (/__/auth/action → /login)
 * - otherwise → configured env authDomain
 */
export function resolveFirebaseAuthDomain(
  configured = environment.firebase?.authDomain || DEFAULT_FIREBASE_AUTH_DOMAIN,
): string {
  if (typeof window === 'undefined') {
    return configured;
  }

  const { hostname, port } = window.location;

  if (
    hostname === DEFAULT_FIREBASE_AUTH_DOMAIN ||
    hostname === QA_FIREBASE_AUTH_DOMAIN ||
    hostname === PROD_FIREBASE_AUTH_DOMAIN
  ) {
    return hostname;
  }

  if (hostname.endsWith('.healthexam.ai') || hostname.endsWith('.healthexam.com')) {
    return hostname;
  }

  if (hostname.endsWith('.web.app') || hostname.endsWith('.firebaseapp.com')) {
    return hostname;
  }

  // Local ng serve (https://localhost:4200) — same pattern as google-idp demo on :4201.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return port ? `${hostname}:${port}` : hostname;
  }

  return configured;
}

export function getFirebaseInitOptions(): FirebaseOptions | null {
  const firebase = environment.firebase;
  if (!firebase?.apiKey) {
    return null;
  }

  return {
    ...firebase,
    authDomain: resolveFirebaseAuthDomain(firebase.authDomain),
  };
}

export function getFirebaseAuthHandlerProxyTarget(): string {
  return `https://${FIREBASE_APP_HOST}`;
}
